// Google Analytics utility functions
declare global {
  interface Window {
    gtag: (
      command: 'config' | 'js' | 'event',
      targetId: string,
      config?: Record<string, any>
    ) => void
  }
}

export const GA_TRACKING_ID = 'G-039ERDCPR0'

// Track page views
export const pageview = (url: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_location: url,
    })
  }
}

// Track custom events
export const event = ({
  action,
  category,
  label,
  value,
}: {
  action: string
  category: string
  label?: string
  value?: number
}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    })
  }
}

// Track ecommerce events
export const trackPurchase = (transactionId: string, value: number, currency: string = 'INR') => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'purchase', {
      transaction_id: transactionId,
      value: value,
      currency: currency,
    })
  }
}

// Track add to cart
export const trackAddToCart = (productId: string, productName: string, value: number) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'add_to_cart', {
      items: [
        {
          item_id: productId,
          item_name: productName,
          value: value,
        },
      ],
    })
  }
}

// Track begin checkout
export const trackBeginCheckout = (value: number, items: Array<{ id: string; name: string; price: number; quantity: number }>) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'begin_checkout', {
      value: value,
      items: items.map(item => ({
        item_id: item.id,
        item_name: item.name,
        price: item.price,
        quantity: item.quantity,
      })),
    })
  }
}

// Enhanced measurement tracking functions
export const trackScrollDepth = (depth: number) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'scroll', {
      scroll_depth: depth,
    })
  }
}

export const trackFormInteraction = (formId: string, action: 'start' | 'submit' | 'error') => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'form_interaction', {
      form_id: formId,
      form_action: action,
    })
  }
}

export const trackOutboundLink = (url: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'click', {
      link_url: url,
      link_type: 'outbound',
    })
  }
}

export const trackFileDownload = (fileName: string, fileType: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'file_download', {
      file_name: fileName,
      file_type: fileType,
    })
  }
}

export const trackVideoEngagement = (videoId: string, action: 'play' | 'pause' | 'complete' | 'seek') => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'video_engagement', {
      video_id: videoId,
      video_action: action,
    })
  }
}

export const trackSiteSearch = (searchTerm: string, resultsCount?: number) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'search', {
      search_term: searchTerm,
      results_count: resultsCount,
    })
  }
} 